import dynamic from 'next/dynamic';

import FenixProvider from '@pedidosya/web-fenix/contexts/FenixContext';

export const FenixProviders = ({
  customTheme,
  children,
  isRevamp,
  fenixVersion,
}) => (
  <FenixProvider
    customTheme={customTheme}
    config={{ revamp: isRevamp, fenixVersion }}
  >
    {children}
  </FenixProvider>
);

export const FenixProvidersDynamic = ({
  customTheme,
  children,
  isRevamp = false,
  fenixVersion,
}) => {
  const Provider = dynamic(
    () => import('@pedidosya/web-fenix/contexts/FenixContext'),
    { ssr: false },
  );

  const config = { revamp: isRevamp, fenixVersion };

  return (
    // @ts-ignore
    <Provider customTheme={customTheme} config={config}>
      {children}
    </Provider>
  );
};
